'use client';

import { type PolymorphicComponent } from '../../types/component';
import { LinkAsAnchor } from './internal/LinkAsAnchor';
import { LinkAsButton } from './internal/LinkAsButton';
import {
  linkClasses,
  type LinkBaseProps,
  type LinkProps,
} from './internal/LinkBase';

type LinkComponent = PolymorphicComponent<LinkBaseProps, 'a'>;

const Link: LinkComponent = (props) => {
  const resolvedProps = {
    underline: 'always',
    color: 'accent-primary',
    variant: 'inherit',
    ...props,
  } as LinkProps;

  const isButton = (resolvedProps.component as string | undefined) === 'button';

  return isButton ? (
    <LinkAsButton {...resolvedProps} />
  ) : (
    <LinkAsAnchor {...resolvedProps} />
  );
};

Link.displayName = 'Link';

export { Link, linkClasses, type LinkProps, type LinkBaseProps };
